import React from 'react';
import './ColumnSelector.css';

const ColumnSelector = ({ columns, visibleColumns, onColumnToggle }) => {
    const handleColumnToggle = (columnKey) => {
        onColumnToggle(columnKey);
    };

    return (
        <div className="column-selector">
            <div className="column-selector-header">
                <h4>Columns</h4>
                <button 
                    className="select-all-btn"
                    onClick={() => {
                        // Toggle between all columns and just essential ones
                        const essentialColumns = ['game_date', 'matchup', 'pts'];
                        const allColumns = columns.map(col => col.key);
                        const newVisibleColumns = visibleColumns.length === allColumns.length 
                            ? essentialColumns 
                            : allColumns;
                        newVisibleColumns.forEach(col => {
                            if (!visibleColumns.includes(col)) {
                                onColumnToggle(col);
                            }
                        });
                        visibleColumns.forEach(col => {
                            if (!newVisibleColumns.includes(col)) {
                                onColumnToggle(col);
                            }
                        });
                    }}
                >
                    {visibleColumns.length === columns.length ? 'Essential Only' : 'Show All'}
                </button>
            </div>
            <div className="column-options">
                {columns.map((column) => (
                    <label key={column.key} className="column-option">
                        <input
                            type="checkbox"
                            checked={visibleColumns.includes(column.key)}
                            onChange={() => handleColumnToggle(column.key)}
                        />
                        <span className="column-label">{column.label}</span>
                    </label>
                ))}
            </div>
        </div>
    );
};

export default ColumnSelector; 